<template>
  <div name="hres3cu-detail-complaint">
  <div class="box-tab">
    <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES3CUC4']['10'] }}
          </h3>
        </div>

        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['20'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="desc_codempid" name="desc_codempid">{{ detail.codempid }} - {{ detail.desc_codempid }}</div>
                  </div>
              </div>
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['30'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="numcom" name="numcom">{{ indexSelected.numcom }}</div>
                  </div>
              </div> 
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['40'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="numcom" name="numcom">{{ setDateOutput(indexSelected.dtecompl) }}</div>
                  </div>
              </div> 
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['50'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="desc_typcompl" name="desc_typcompl">{{ detail.typcompl }} - {{ detail.desc_typcompl }}</div>
                  </div>
              </div>
        
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['60'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="descompl" name="descompl">{{ detail.descompl }}</div>
                  </div>
              </div> 

              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['70'] }}</div>
                  <div class="detail-right">
                      <input type="radio" id="stacompl1" value="N" v-model="indexSelected.stacompl" disabled="disabled"> <span class="radio-text">{{ labels['HRES3CUC4']['80'] }}</span>
                      <input type="radio" id="stacompl2" value="D" v-model="indexSelected.stacompl" disabled="disabled"> <span class="radio-text">{{ labels['HRES3CUC4']['90'] }}</span>
                  </div>              
              </div> 
              <div class="clearfix detail-row">
                  <div class="detail-left label-left"></div>
                  <div class="detail-right">
                      <input type="radio" id="stacompl3" value="S" v-model="indexSelected.stacompl" disabled="disabled"> <span class="radio-text">{{ labels['HRES3CUC4']['100'] }}</span>
                      <input type="radio" id="stacompl4" value="C" v-model="indexSelected.stacompl" disabled="disabled"> <span class="radio-text">{{ labels['HRES3CUC4']['110'] }}</span>
                  </div>              
              </div>   
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['120'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="desc_codappv" name="desc_codappv">{{ detail.codappv }} - {{ detail.desc_codappv }}</div>
                  </div>
              </div>
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['130'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="filenam1" name="filenam1"><a :href="detail.path_filenam1" target="_blank">{{ detail.filenam1 }}</a></div>
                  </div>
              </div>
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['140'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="filenam2" name="filenam2"><a :href="detail.path_filenam2" target="_blank">{{ detail.filenam2 }}</a></div>
                  </div>
              </div>
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['150'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="filenam3" name="filenam3"><a :href="detail.path_filenam3" target="_blank">{{ detail.filenam3 }}</a></div>
                  </div>
              </div>
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['160'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70">{{ detail.desnote }}</div>
                  </div>
              </div>
            </div>
            
          </div>
        </div>
        <div class="box-footer">
            <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
        </div>
      </div> 
    </div> 
  </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres3cu-detail-complaint',
  props: [ 'labels', 'detail', 'toggle', 'data', 'nowLang', 'labelsButton', 'indexSelected' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// detailComplaint.vue?4a6e56b6